<script setup>
import NLoading from '/app/components/NLoading.vue';
</script>

<template>
    <div class="flex flex-col grow">
        <Suspense>
            <RouterView />
            <template #fallback>
                <div class="flex items-center justify-center h-full">
                    <NLoading />
                </div>
            </template>
        </Suspense>
    </div>
</template>